export const APPLICANT_FILE_MAX_SIZE = 1024 * 1024 * 20;
